import { FC } from 'react';

import { LectureAbstractMarkdown } from '@/components/ui/shared/markdowns/LectureAbstractMarkdown/LectureAbstractMarkdown';

interface IAbstractContent {
  content: string;
}

export const AbstractContent: FC<IAbstractContent> = ({ content }) => {
  return (
    <LectureAbstractMarkdown
      source={content}
      h="full"
      w="full"
      overflow="auto"
      p={{ base: '16px 24px', md: '32px 64px', lg: '32px 16% ' }}
    />
  );
};
